import { render, staticRenderFns } from "./OrderOrderAccountingHb.vue?vue&type=template&id=5638d928&scoped=true&"
import script from "./OrderOrderAccountingHb.vue?vue&type=script&lang=js&"
export * from "./OrderOrderAccountingHb.vue?vue&type=script&lang=js&"
import style0 from "./OrderOrderAccountingHb.vue?vue&type=style&index=0&id=5638d928&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5638d928",
  null
  
)

export default component.exports